
import { useResourceUsage } from './use-resource-usage';
import { useSubscriptionData } from './use-subscription-data';
import { useAuth } from '@/contexts/AuthContext';

export const usePremiumBotUsage = () => {
  const { user } = useAuth();
  const { data: subscriptionData } = useSubscriptionData(user?.id);
  const { data: resourceUsage } = useResourceUsage(user?.id);

  const currentCount = resourceUsage?.premiumBotAccountsCount || 0;
  const maxCount = subscriptionData?.package?.max_premium_bots || 0;
  const canUsePremiumBot = currentCount < maxCount;

  const getErrorMessage = () => {
    if (!subscriptionData?.package) {
      return 'No active subscription found. Please upgrade to use premium bots.';
    }

    if (currentCount >= maxCount) {
      return `You've reached your limit of ${maxCount} premium bot connections. Please upgrade your subscription to add more.`;
    }

    return null;
  };

  return {
    canUsePremiumBot,
    currentCount,
    maxCount,
    getErrorMessage
  };
};
